document.addEventListener('click', function (e) {
    let btn = e.target.closest('.ts-promo-badge__code');
    if (!btn) return;

    let code = btn.getAttribute('data-promo-code');
    if (!code) return;

    function showCopied() {
      let originalText = btn.textContent;
      let copiedLabel = btn.getAttribute('data-copy-label') || 'Copied';
      btn.textContent = copiedLabel;
      btn.classList.add('ts-promo-badge__code--copied');

      setTimeout(function () {
        btn.textContent = originalText;
        btn.classList.remove('ts-promo-badge__code--copied');
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(showCopied);
    } else {
      let textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(textarea);
      showCopied();
    }
});